import { useTranslations } from "next-intl";
import { Spinner } from "@/components/ui/spinner";

export const LoadingElement = () => {
  const t = useTranslations();
  return (
    <div className="flex items-center gap-2 text-muted-foreground text-sm">
      <Spinner className="size-4" />
      <span>{t("general.loadingLabel")}</span>
    </div>
  );
};
